/**
 * Query keys for contract date calculation
 * Centralized query key definitions for TanStack Query cache management
 */

/**
 * Query keys for contract date calculations
 * Following TanStack Query best practices for hierarchical cache keys
 *
 * @example
 * // Invalidate all contract date calculations
 * queryClient.invalidateQueries({ queryKey: contractDateKeys.all });
 *
 * // Cache or retrieve calculation for specific childcare
 * queryClient.setQueryData(contractDateKeys.calculation(childcareId), data);
 */
export const contractDateKeys = {
  all: ['contract-dates'] as const,
  calculation: (childcareId: string) => [...contractDateKeys.all, 'calculation', childcareId] as const,
};
